import React, { createContext, useMemo, useCallback, useState } from 'react';

import PropTypes from 'prop-types';
import { usePersistedState } from '../utils/Common';

export const DomainContext = createContext();


export const DomainProvider = ({ children }) => {
  const [domainImages, setDomainImages] = usePersistedState('domainImages', {});
  const [selectDomains, setSelectDomains] = usePersistedState('selectDomains', []);
  const [domainId,setDomainId] = usePersistedState('domainId', undefined);
  const [firmId,setFirmId] = usePersistedState('firmId', undefined);
 
  const [groupedDomainsByDomain, setGroupedDomainsByDomain] = useState({});
  const [domainData, setDomainData] = usePersistedState('domainData', {
    categoryIds: [],
    entityIds: [],
    users: [],
    addressIds: []
  });
 
  const clearDomainState = useCallback(() => {
    setSelectDomains([]);  
    setDomainImages([]);
    setDomainId(undefined);
    setFirmId(undefined);
   setDomainData(undefined);
   setGroupedDomainsByDomain({});
    localStorage.removeItem("domainImages");
    localStorage.removeItem("selectDomains");
  }, [setDomainData, setDomainId, setDomainImages, setFirmId, setSelectDomains]);

  const value = useMemo(() => ({
   domainImages,clearDomainState,selectDomains,setSelectDomains,setDomainImages,domainData,setDomainData,groupedDomainsByDomain, setGroupedDomainsByDomain,firmId,setFirmId,domainId,setDomainId
  }), [domainImages, clearDomainState, selectDomains, setSelectDomains, setDomainImages, domainData, setDomainData, groupedDomainsByDomain, firmId, setFirmId, domainId, setDomainId]);

  
  return (
    <DomainContext.Provider value={value}>
      {children}
    </DomainContext.Provider>
  );
};
DomainProvider.propTypes = {
 children: PropTypes.node,
  };
  
  